import {
	Box,
	Card,
	Divider,
	Group,
	Skeleton,
	Stack,
	createStyles,
} from '@mantine/core';
import {
	PageLayoutContent,
	PageLayoutContentWrapper,
	PageLayoutOuterWrapper,
	PageLayoutWrapper,
} from '../../../components/PageLayout';
import {
	NavBarBreadcrumbWrapper,
	NavBarSidesheetControlsWrapper,
	NavBarWrapper,
} from '../../../components/SecodaAppShell/SecodaNavBar';

const useStyles = createStyles((theme) => ({
	card: {
		backgroundColor: theme.other.getColor('surface/primary/default'),
		border: `1px solid ${theme.other.getColor('border/secondary/default')}`,
	},
	skeleton: {
		backgroundColor: theme.other.getColor('fill/tertiary/default'),
	},
}));

export function BIMetricPageSkeleton() {
	const { classes } = useStyles();
	return (
		<PageLayoutOuterWrapper>
			<PageLayoutWrapper name="bi-metric-skeleton">
				<PageLayoutContentWrapper name="bi-metric-skeleton">
					<NavBarWrapper>
						<NavBarBreadcrumbWrapper>
							<Box px="xs">
								<Skeleton height={28} width={120} radius="sm" />
							</Box>
						</NavBarBreadcrumbWrapper>
						<NavBarSidesheetControlsWrapper>
							<Group spacing="xs">
								<Skeleton height={28} width={28} radius="sm" />
								<Skeleton height={28} width={28} radius="sm" />
							</Group>
						</NavBarSidesheetControlsWrapper>
					</NavBarWrapper>
					<PageLayoutContent>
						<Stack spacing="md">
							{/* Header section with title and navigation */}
							<Stack spacing="sm">
								{/* Two horizontal navigation lines */}
								<Stack spacing="xs">
									<Skeleton height={12} width="85%" radius="sm" />
									<Skeleton height={12} width="85%" radius="sm" />
								</Stack>

								{/* Four tab-like elements */}
								<Group spacing="md" mt="sm">
									<Skeleton height={12} width={80} radius="sm" />
									<Skeleton height={12} width={80} radius="sm" />
									<Skeleton height={12} width={80} radius="sm" />
									<Skeleton height={12} width={80} radius="sm" />
								</Group>
							</Stack>

							<Divider />

							{/* Large main content area */}
							<Card className={classes.card}>
								<Skeleton
									height="60vh"
									width="100%"
									radius="sm"
									className={classes.skeleton}
								/>
							</Card>
						</Stack>
					</PageLayoutContent>
				</PageLayoutContentWrapper>
			</PageLayoutWrapper>
		</PageLayoutOuterWrapper>
	);
}
